/* eslint-disable react/no-children-prop */
/* eslint-disable react/prefer-stateless-function */
import React, { PureComponent } from 'react';
import { Button, ButtonToolbar, Alert } from 'reactstrap';
import NotificationSystem from 'rc-notification';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import Select from 'react-select';
import TextField from '@material-ui/core/TextField';
// import IconButton from '@material-ui/core/IconButton';
// import PenIcon from 'mdi-react/PenIcon';
import { BasicNotification } from '../../../../shared/components/Notification';
// import { editUser, resetUser } from '../../../../redux/actions/userActions';
import { getGenderName, customStyles } from '../../../../utils/functions';
import firebaseAuth from '../../../../utils/firebase';
// import callDb from '../../../../utils/server';
// import ModalDelete from './ModalDelete';
// import ModalEmail from './ModalEmail';
import IdentityCheck from './IdentityCheck';
import { getMyIdp, getMyEmail, logout } from '../../../../utils/auth';
import { resetAssets } from '../../../../redux/actions/assetsActions';
import { resetParams } from '../../../../redux/actions/paramsActions';
import { resetAccessesReceived } from '../../../../redux/actions/accessReceivedActions';

const genderOptions = [
  { type: 'gender', value: 'male', label: 'M.' },
  { type: 'gender', value: 'female', label: 'Mme' },
];

let notification = null;

const showNotif = (color, title, text) => {
  if (!notification) {
    console.log('notification broken');
    return;
  }
  notification.notice({
    content: <BasicNotification
      color={color}
      title={title}
      message={text}
    />,
    duration: 5,
    closable: true,
    style: { top: 0, left: 'calc(100vw - 100%)' },
    className: 'right-up ltr-support',
  });
};

class ProfileInformation extends PureComponent {
  static propTypes = {
    // handleSubmit: PropTypes.func.isRequired,
    // reset: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    user: PropTypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);
    this.myIdp = getMyIdp();
    this.myEmail = getMyEmail();
    const { user } = props;
    const { email } = firebaseAuth().currentUser;
    this.state = {
      ...user,
      email,
      // isModalDelete: false,
      // isModalEmail: false,
    };
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, (n) => { notification = n; });
  }

  handleSelectChange = (event) => {
    console.log(event);
    if (event) {
      this.setState({ [event.type]: event.value });
    } else {
      console.log('no event detected');
    }
  };

  saveData = (allInfo) => {
    console.log(allInfo);
    // const { dispatch } = this.props;
    // callDb(allInfo, 'users/editOne').then(() => {
    //   dispatch(editUser(this.state));
    //   analytics.logEvent('user_edited');
    //   showNotif('success', 'Succés', 'Vos informations ont bien été mises à jour');
    // }).catch((err) => {
    //   console.log(err);
    //   showNotif('danger', 'Erreur', 'Un problème est survenu, vos informations n\'ont pas été mises à jour');
    // });
  }

  submitData = () => {
    const {
      family_name, given_name, gender, birthdate, birth_country, birth_city, birth_code,
    } = this.state;
    const allInfo = {
      family_name, given_name, gender, birthdate, birth_country, birth_city, birth_code,
    };
    this.saveData(allInfo);
  }

  submitMetaData = () => {
    const { email, phone_number, address } = this.state;
    const allInfo = { email, phone_number, address };

    this.saveData(allInfo);
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // confirmDelete = () => {
  //   const { dispatch } = this.props;
  //   const userFb = firebaseAuth().currentUser;
  //   callDb({}, 'users/delete-myself').then(() => {
  //     userFb.delete().then(() => {
  //       showNotif('success', 'Compte supprimé', 'Votre compte et toutes ses données ont bien été supprimés');
  //       dispatch(resetUser());
  //       this.toggleModalDelete();
  //     }).catch((error) => {
  //       console.log(error);
  //       showNotif('danger', 'Erreur', 'Un problème est survenu, votre compte n\'a pu être supprimé intégralement');
  //       this.toggleModalDelete();
  //     });
  //   }).catch((err) => {
  //     console.log(err);
  //     this.toggleModalDelete();
  //     showNotif('danger', 'Erreur', 'Un problème est survenu, votre compte n\'a pu être supprimé');
  //   });
  // }

  /* eslint-disable consistent-return */
  signOut = (path) => {
    console.log('logging user out');
    const { dispatch } = this.props;
    logout();
    if (path) {
      dispatch(resetAssets());
      dispatch(resetParams());
      dispatch(resetAccessesReceived());
      window.location = path;
    } else {
      console.log('error: not path for logout');
    }
  }

  confirmEditEmail = (path) => {
    showNotif('success', 'Succés', 'Adresse E-mail mise à jour');
    this.toggleModalEmail();
    if (path) this.signOut(path);
  }

  // openModalDelete = () => {
  //   this.setState({ isModalDelete: true });
  // }

  // toggleModalDelete = () => {
  //   this.setState(prevState => ({ isModalDelete: !prevState.isModalDelete }));
  // }

  // toggleModalEmail = () => {
  //   this.setState(prevState => ({ isModalEmail: !prevState.isModalEmail }));
  // }

  render() {
    const {
      family_name, given_name, gender, email, birthdate, birth_country, birth_city, birth_code, phone_number, address,
    } = this.state;
    const { user } = this.props;
    const { identity } = user;
    // console.log(isModalDelete);
    return (
      <div>
        {(!identity || (identity && !identity.isVerified)) && <IdentityCheck />}
        <form className="form form--horizontal">
          <h4 className="bold-text mt-20 mb-20">À propos de moi</h4>
          <div className="form__form-group">
            <span className="form__form-group-label">Civilité</span>
            <div className="form__form-group-field">
              {
                (identity && identity.isVerified && identity.provider === 'FC') ? (
                  <input
                    type="text"
                    value={getGenderName(gender)}
                    disabled
                  />
                ) : (
                  <Select
                    options={genderOptions}
                    type="gender"
                    onChange={this.handleSelectChange}
                    defaultValue={{ label: getGenderName(gender), value: gender }}
                    className="fullWidth"
                    placeholder="Choisir"
                    theme={customStyles}
                  />
                )
              }
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Nom de naissance</span>
            <div className="form__form-group-field">
              <input
                type="text"
                value={family_name}
                name="family_name"
                onChange={this.onChange}
                disabled={identity && identity.isVerified && identity.provider === 'FC'}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Prénom(s)</span>
            <div className="form__form-group-field">
              <input
                type="text"
                value={given_name}
                name="given_name"
                onChange={this.onChange}
                disabled={identity && identity.isVerified && identity.provider === 'FC'}
              />
            </div>
          </div>
          <div className="form__form-group noMui">
            <span className="form__form-group-label">Date de naissance</span>
            <div className="form__form-group-field">
              <TextField
                id="date"
                type="date"
                name="birthdate"
                value={birthdate}
                className="form__form-group-datepicker fullWidth"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={this.onChange}
                disabled={identity && identity.isVerified && identity.provider === 'FC'}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Pays de naissance</span>
            <div className="form__form-group-field">
              <input
                type="text"
                value={birth_country}
                name="birth_country"
                onChange={this.onChange}
                disabled={identity && identity.isVerified && identity.provider === 'FC'}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Ville de naissance</span>
            <div className="form__form-group-field">
              <input
                type="text"
                value={birth_city}
                name="birth_city"
                onChange={this.onChange}
                disabled={identity && identity.isVerified && identity.provider === 'FC'}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Code postal de naissance</span>
            <div className="form__form-group-field">
              <input
                type="text"
                value={birth_code}
                name="birth_code"
                onChange={this.onChange}
                disabled={identity && identity.isVerified && identity.provider === 'FC'}
              />
            </div>
          </div>
          <Alert color="info" className="fullWidth">
            Ces informations étant liées à votre identité, elles ne peuvent être modifiées.
          </Alert>
        </form>
        <form className="form form--horizontal">
          <h4 className="bold-text mt-20 mb-20">Mes coordonnées</h4>
          <div className="form__form-group">
            <span className="form__form-group-label">Email</span>
            <div className="form__form-group-field">
              <input
                type="email"
                value={email}
                name="email"
                disabled
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Téléphone</span>
            <div className="form__form-group-field">
              <input
                type="text"
                value={phone_number}
                name="phone_number"
                onChange={this.onChange}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Adresse de l'étude</span>
            <div className="form__form-group-field">
              <input
                type="text"
                value={address}
                name="address"
                onChange={this.onChange}
              />
            </div>
          </div>
          <div className="form__form-group">
            <ButtonToolbar className="form__button-toolbar">
              <Button color="official" onClick={this.submitMetaData}>Enregistrer les modifications</Button>
            </ButtonToolbar>
          </div>
        </form>
        <div>
          <h4 className="bold-text mt-20 mb-20">Mon compte</h4>
          <Button onClick={this.openModalDelete} color="link" className="reddish">
            Supprimer mon compte
          </Button>
          <div className="fs10 mt-6 additional-text">Non disponible pour le FICONUM, veuillez nous contacter à l'adresse contact@legitbee.com si besoin</div>
        </div>
        {/* {isModalDelete && <ModalDelete myIdp={this.myIdp} identity={identity} toggle={this.toggleModalDelete} isModal={isModalDelete} confirmDelete={this.confirmDelete} />}
        {isModalEmail && <ModalEmail myIdp={this.myIdp} user={user} toggle={this.toggleModalEmail} isModal={isModalEmail} confirmEditEmail={this.confirmEditEmail} />} */}
      </div>
    );
  }
}

// export default ProfileInformation;
export default reduxForm({
  form: 'profile_settings_form', // a unique identifier for this form
})(ProfileInformation);
